var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20 lg:mb-[160px]"},[_c('FaqBanner'),_vm._v(" "),_c('FaqList',{staticClass:"mt-8"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }